<template>
  <div>
    <el-upload
      class="upload-demo"
      :action='_url'
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :before-upload="beforeupload"
      :on-success='onSuccess'
      :show-file-list='show_file_list'
      :multiple='multiple'
      :on-exceed="handleExceed"
      :data ='filename'>
      <el-button size="small" type="primary">数据导入</el-button>
    </el-upload>
    <el-dialog
			title="提示"
			:close-on-click-modal="false"
			:visible.sync="messageInfo"
      :append-to-body="true"
			width="30%">
    <div v-html="info" style="text-align:left"></div>
    </el-dialog>
  </div>
</template>

<script>
import mixins from '@/Mixins'
  import { Loading } from 'element-ui'
  export default {
    name: 'file_Upload',
    mixins:[ mixins ],
    props:{ _url: String },
    data() {
      return {
        multiple:false,
        show_file_list:false,
        filename:{ file:'' },
        messageInfo:false,
        loadingInstance1:false,
        info:''
      }
    },
    methods: {
      handleRemove(file, fileList) {
        console.log(file, fileList)
      },
      handlePreview(file) {
        console.log(file)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`)
      },
      beforeupload(file) {
        this.loadingInstance1 = Loading.service({
          lock: true,
          text: '导入中需要一定的时间，请勿关闭！',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          fullscreen: true 
        })
        let [vn = this] = []
        vn.filename.file = file.name
        const isJPG = file.type === 'image/jpeg'
        isJPG ? vn._tips({message:'只能上传 xls 格式的文件', type:'error'}) : ''
      },
      onSuccess(response, file, fileList) {
        console.log(response)
        let [vm] = [this]
        vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          vm.loadingInstance1.close()
        })
        switch (response.status) {
          case 0:
            // vm._tips({message:'上传成功'})
            let result = JSON.parse(response.data)
            let failDataList = JSON.parse(result.failedResult)
            // console.log(result)
            console.log(failDataList)
            let listStr = ''
            if (result.failedCount !== 0) {
							listStr = `
								<p style="height:30px;line-height:30px;">导入失败 <strong style="color:red;">${result.failedCount}</strong> 条</p>
								<p style="margin-left:40px;height:30px;line-height:30px;">错误原因 —— 错误数据
							`
              if (failDataList[0].idCard) {
                failDataList.forEach(i => {
                  listStr += '<p style="margin-left:40px;height:24px;line-height:24px;">'+i.error+' —— 身份证：<strong style="color:red;">'+i.idCard+'</strong></p>'
                })
              } else if (failDataList[0].socialCode) {
                failDataList.forEach(i => {
                  listStr += '<p style="margin-left:40px;height:24px;line-height:24px;">'+i.error+' —— 社会信用码：<strong style="color:red;">'+i.socialCode+'</strong></p>'
                })
              } else if (failDataList[0].name) {
                failDataList.forEach(i => {
                  listStr += '<p style="margin-left:40px;height:24px;line-height:24px;">'+i.error+' —— 名称：<strong style="color:red;">'+i.name+'</strong></p>'
                })
              } else if (failDataList[0].organizationName) {
                failDataList.forEach(i => {
                  listStr += '<p style="margin-left:40px;height:24px;line-height:24px;">'+i.error+' —— 企业名称：<strong style="color:red;">'+i.organizationName+'</strong></p>'
                })
              }
              // console.log(failDataList);
              
              // listStr += ' </p><p style="color:red;">* 可能造成的原因：地区错误 *</p>'
            }
            // if (result.duplicateCount !== 0) {
            //    listStr += '<p style="margin-left:20px;">重复数据 <strong style="color:red;">'+result.duplicateCount+'</strong> 条</p>'
            // }
            this.info = `<p style="height:30px;line-height:30px;">导入成功 <strong style="color:green;">${result.successCount+result.duplicateCount}</strong> 条</p>${listStr}`
            // this.$alert(code, '上传结果', { dangerouslyUseHTMLString: true })
            this.messageInfo = true
            break;
          case 1: vm._tips({message:'用户已被冻结' , type : 'error'}); break;
          case 2: vm._tips({message:'用户不存在' , type : 'error'}); break;
          case 3: vm._tips({message:'用户名或者密码错误' , type : 'error'}); break;
          case 4: vm._tips({message:'用户未登录' , type : 'error'}); break;
          case 5: vm._tips({message:'目录名已存在' , type : 'error'}); break;
          case 6: vm._tips({message:'不是管理员' , type : 'error'}); break;
          case 7: vm._tips({message:'系统错误' , type : 'error'}); break;
          case 8: vm._tips({message:'名称已存在' , type : 'error'}); break;
          case 9: vm._tips({message:'分站管理员已经存在' , type : 'error'}); break;
          case 10: vm._tips({message:'权限不够' , type : 'error'}); break;
          case 11: vm._tips({message:'权限不够' , type : 'error'}); break;
          case 12: vm._tips({message:'模板已过期' , type : 'error'}); break;
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {}
/deep/ .el-dialog {height: auto;max-height: 600px;overflow: auto;margin-top: 15vh !important;}
/deep/ .el-dialog__body {padding: 30px 50px 50px;}
</style>